import { t } from 'ttag'
import { useMemo } from 'react'

import { SLB } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Option, OptionGroup } from '@h2/components/containers/optionGroup'
import { AdultEducationIcon } from '@h2/components/icons/adultEducation'
import { HigherEducationIcon } from '@h2/components/icons/higherEducation'
import { K12Icon } from '@h2/components/icons/k12'
import { Card } from '@h2/common/components/card'

import { props } from './props'
import { ContentWrap, OptionBody } from './components'

import { Navigator } from '../highlights/navigator'
import { Back } from '../back'
import { Controls } from '../controls'

const EducatorType = ({ inDialog, properties, validate, renderPanel }) => {
  const educatorType = useMemo(() => properties.educatorType, [properties.educatorType])

  return (
    <Card inDialog={inDialog}>
      <Card.Highlight color={SLB}>
        <Navigator type="educator" />
      </Card.Highlight>
      <Card.Content>
        <ContentWrap>
          <Heading level="2" align="center" mb="12px">
            {t`My students are...`}
          </Heading>
          <Text align="center">{t`Let us know the stage of education you are in.`}</Text>
          <OptionGroup
            gap="15px"
            value={educatorType}
            onClick={value => validate({ educatorType: value })}>
            <Option value="k12">
              <OptionBody>
                <K12Icon size="large" />
                <span className="flex">
                  <span>{t`K-12`}</span>
                  <span>{t`Between kindergarten and 12th grade`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="higher_ed">
              <OptionBody>
                <HigherEducationIcon size="large" />
                <span className="flex">
                  <span>{t`Higher Ed`}</span>
                  <span>{t`They are attending college`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="adult">
              <OptionBody>
                <AdultEducationIcon size="large" />
                <span className="flex">
                  <span>{t`Adult Ed`}</span>
                  <span>{t`They are attending adult education`}</span>
                </span>
              </OptionBody>
            </Option>
          </OptionGroup>
          <Controls>
            <Back onClick={() => renderPanel('navigatorType')} />
          </Controls>
        </ContentWrap>
      </Card.Content>
      <Card.Detour>
        <Back onClick={() => renderPanel('navigatorType')} />
      </Card.Detour>
    </Card>
  )
}

EducatorType.propTypes = { ...props }

export { EducatorType }
